define(
    'plugins/musicfavourite',[
        './musicfavourite/ui/button',
        './musicfavourite/ui/dialogs',
        './musicfavourite/events',
        './musicfavourite/ui/dom',
        './musicfavourite/env',
        'exports'
    ],
    function(
        Button,
        dialogs,
        PubSub,
        DOM,
        env,
        exports
    ) {
        'use strict';

        exports = exports || {};

        PubSub.context('button', exports);

        exports.Button = Button;


        /**
         * Creates a new Music Favourite button.
         *
         * @param {string|DOMElement|object} selector Attributes for favourite button. Can be a DOM element or nodeSpec
         *     which will extract favourite attributes from the element, and render the button within. Or a object
         *     map which will create and render a new favourite button.
         */

        // Used in refresh and initialise
        function refreshButtons(selector) {
            var newButtons = Button.createFromSelector(selector);
            exports.all = exports.all ? exports.all.concat(newButtons) : newButtons;
            return newButtons;
        }

        function prepareConfirmation() {
            var elDismiss = DOM.findElement('.p-f-conf-dismiss');
            if (typeof elDismiss != 'undefined' && elDismiss && elDismiss.length > 0) {
                DOM.on(elDismiss[0], 'click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    exports.publish('confirmation.dismissed');

                    DOM.addClass(DOM.findElement('.p-f-confirmation'), 'p-f-dismissed');

                    setTimeout(function() {
                        DOM.addClass(DOM.findElement('.p-f-confirmation'), 'p-f-hide');
                        DOM.removeClass(DOM.findElement('.p-f-confirmation'), 'p-f-dismissed');
                    }, 500);
                });
            }
        }

        function createManagementPanel(buttonElement, id) {
            var template = [
                '<div class="p-f-management-panel">',
                '<div class="p-f-management-panel-label">',
                '<span class="p-f-management-panel-label-text"></span>',
                '</div>',
                '<button id="pf', id, '-confirm" class="p-f-management-panel-button confirm">',
                '<span class="p-f-management-panel-button-text"></span>',
                '</button>',
                '<button id="pf', id, '-cancel" class="p-f-management-panel-button cancel">',
                '<span class="p-f-management-panel-button-text"></span>',
                '</button>',
                '</div>'
            ].join('');
            DOM.append(buttonElement, template);
        }

        function createOptionsPanel(buttonElement, id) {
            var template = [
                '<div id="', id, '-options" class="p-f-options-button">',
                '<i aria-hidden="true" class="gelicon gelicon--more"></i></div>',
                '<div class="p-f-options-panel">',
                '<div id="', id, '-feedback" class="p-f-feedback-button">',
                '<span class="p-f-feedback-label"></span></div></div>'
        ].join('');
            DOM.append(buttonElement, template);
        }

        /**
         * Initialise JavaScript components of Favourite button markup embedded on the page.
         */
        exports.initialise = function() {
            prepareConfirmation();
            exports.publish('initialise');
            exports.publish('initialised', refreshButtons());
            return exports.all;
        };


        /**
         * Looks for new Favourite buttons on the page, and initialises JS for them.
         * @return {Array} New Buttons found on the page.
         */
        exports.refresh = function() {
            exports.publish('refresh');
            var newButtons = refreshButtons();
            exports.publish('refreshed', newButtons);
            return newButtons;
        };


        /**
         * Counts number of times render was called - used for id generation.
         * @type {Number}
         */
        var _renderCount = 0;

        /**
         * Renders a JS only Music Favourite button
         * @param  {string|DOMElement} parentElement jQuery type selector or element in which to render button.
         * @param  {object} input         Options for favourite button.
         */
        exports.render = function(parentElement, input) { // TODO: refactor into ui/button.js
            parentElement = (DOM.findElement(parentElement).length) ? DOM.findElement(parentElement) : DOM.findElement('body');
            input = input || {};

            _renderCount++;
            var id = 'j' + _renderCount, // sequential id generation with "j" appended so as to not conflict with PHP rendered buttons
                element, options = {},
                key, i, profilePath = 'profiles/default/',
                _validOptions = [
                    'id', 'type', 'title', 'appid', 'aux', 'ptrt', 'variant', 'profile', 'lang', 'label', 'font-size',
                    'product', 'platform', 'context-id', 'context-type', 'management-mode', 'openInNewWindow', 'fills-container',
                    'card-selector', 'feedback-mode', 'default-added', 'use-modal-signin', 'clip-format',
                    'use-signin-overlay' // Radio player is setting "use-signin-overlay" (PSP-2613)
                ];

            for (i = 0;
                (key = _validOptions[i]); i++) {
                if (input[key] !== undefined) { //Using undefined for int values to pass the if statement
                    options[key] = input[key];
                }
            }

            if (options.profile && options.profile !== '') {
                profilePath = 'profiles/' + options.profile + '/';
            }

            // Normalise locales to always include the GB region sub-tag
            if (['en', 'cy', 'ga', 'gd'].indexOf(options.lang) !== -1) {
                options.lang += '-gb';
            }

            var template = [
                '<span class="p-f" id="pmfs', id, '">',
                '<span class="p-form">',
                '<button id="pf', id, '" type="submit" class="p-f-button" aria-labelledby="pfl', id, '" aria-live="polite" aria-pressed="false">',
                '<span class="p-f-icon">',
                '<img src="', env.resolveStaticURL(profilePath + 'img/sprite.png'), '" class="p-f-icon-sprite" width="128" height="384" alt="">',
                '<img src="', env.resolveStaticURL(profilePath + 'img/spinner.gif'), '" class="p-f-icon-spinner" width="128" height="128" alt="">',
                '</span>',
                '<span class="p-f-gelicon">',
                '<i aria-hidden="true" class="p-f-gelicon-add gelicon gelicon--add"></i>',
                '<i aria-hidden="true" class="p-f-gelicon-added gelicon gelicon--yes"></i>',
                '<i aria-hidden="true" class="p-f-gelicon-remove gelicon gelicon--no"></i>',
                '<i aria-hidden="true" class="p-f-gelicon-spinner gelicon gelicon--load"></i>',
                '</span>',
                '<span id="pfl', id, '" class="p-f-label p-f-hidden" tabindex="-1">', '</span>',
                '<span class="p-f-label-display p-f-show" role="presentation" aria-hidden="true">',
                '<span class="p-f-label-text">', '</span>',
                '<span class="p-f-label-action">', '</span>',
                '</span>',
                '</button>',
                '</span>',
                '</span>'
            ].join('');

            DOM.append(parentElement, template);

            element = (DOM.findElement('#pmfs' + id).length) ? DOM.findElement('#pmfs' + id) : document.getElementById('pmfs' + id);

            if (options.id) DOM.setAttr(element, 'data-id', options.id);
            if (options.type) DOM.setAttr(element, 'data-type', options.type);
            if (options.title) DOM.setAttr(element, 'data-title', options.title);
            if (options.appid) DOM.setAttr(element, 'data-appid', options.appid);
            if (options.aux) DOM.setAttr(element, 'data-aux', options.aux);
            if (options.ptrt) DOM.setAttr(element, 'data-ptrt', options.ptrt);

            if (options.product) DOM.setAttr(element, 'data-product', options.product);
            if (options.platform) DOM.setAttr(element, 'data-platform', options.platform);
            if (options['context-id']) DOM.setAttr(element, 'data-context-id', options['context-id']);
            if (options['context-type']) DOM.setAttr(element, 'data-context-type', options['context-type']);
            if (options['card-selector']) DOM.setAttr(element, 'data-card-selector', options['card-selector']);
            if (options.label && typeof options.label === 'object') DOM.setAttr(element, 'data-label', JSON.stringify(options.label));

            if (options['use-signin-overlay'] !== undefined) DOM.setAttr(element, 'data-use-signin-overlay', options['use-signin-overlay']);

            if (options.variant) {
                DOM.setAttr(element, 'data-variant', options.variant);
                DOM.addClass(element, 'p-f-variant-' + options.variant);
            }
            if (options.profile) {
                DOM.setAttr(element, 'data-profile', options.profile);
                DOM.addClass(element, 'p-f-p_' + options.profile);
            }
            if (options.lang) {
                DOM.setAttr(element, 'data-lang', options.lang);
                DOM.addClass(element, 'p-f-lang-' + options.lang.toLowerCase());
            }
            if (options['management-mode']) {
                DOM.setAttr(element, 'data-management-mode', '1');
                DOM.addClass(element, 'p-f-management-mode');
                createManagementPanel(element, id);
            }
            if (options['feedback-mode']) {
                DOM.setAttr(element, 'data-feedback-mode', '1');
                DOM.addClass(element, 'p-f-feedback-mode');
                createOptionsPanel(element, id);
            }
            if (options['fills-container']) {
                DOM.setAttr(element, 'data-fills-container', '1');
                DOM.addClass(element, 'p-f-fills-container');
            }
            if (options.openInNewWindow) {
                DOM.setAttr(element, 'data-openinnewwindow', '1');
            }
            if (options['use-modal-signin']) {
                DOM.setAttr(element, 'data-use-modal-signin', '1');
            }
            if (options['font-size']) {
                DOM.css(element, { 'font-size': options['font-size'] });
            }
            if (options['default-added']) {
                DOM.setAttr(element, 'data-default-added', '1');
            }

            exports.initialise();
        };



        // Initialise dialogs::
        dialogs.initialise(exports);

        return exports;
    }
);
